import { HttpMethod } from "../../common/constants/http-requests";
import { httpRequest, httpRequestForFile } from "../../common/utils/http-request";
import { PROJECT_ADMIN_API } from "../api";

export const getProjectAdminDetails = (pageNo, pageSize, sortDir, sortBy, searchData, expiredAllocations, clientId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/get-projects?page=${pageNo}&pagesize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchKey=${searchData}&expiredAllocations=${expiredAllocations}${clientId ? `&clientId=${clientId}` : ''}`,
    method: HttpMethod.GET,
  });

export const postProjectAdminDetails = (data) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/add-project`,
    method: HttpMethod.POST,
    data: data,
  });

export const updateProjectAdminDetails = (data) => {
  const projectId = data?.projectId ?? data?.ProjectId;
  if (projectId == null || projectId === "") {
    return Promise.reject(new Error("Project ID is required for update."));
  }
  return httpRequest({
    url: `${PROJECT_ADMIN_API}/${projectId}/update-project`,
    method: HttpMethod.PUT,
    data: data,
  });
};

export const deleteProjectAdminDetails = (projectId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/${projectId}/delete-project`,
    method: HttpMethod.DELETE,
  });

export const postProjectAdminFile = (data) =>
  httpRequestForFile({
    url: `${PROJECT_ADMIN_API}/upload-sow?projectId=${data.id}&projectName=${data.name}`,
    method: HttpMethod.POST,
    data: data.data
  });

export const getProjectById = (projectId) => 
  httpRequest({
    url: `${PROJECT_ADMIN_API}/${projectId}`,
    method: HttpMethod.GET,
  });

export const getLinkedSOWIdsByProjectId = (projectId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/${projectId}/linked-sows`,
    method: HttpMethod.GET,
  });

export const getLinkedSOWsByProjectId = (projectId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/${projectId}/linked-sows-list`,
    method: HttpMethod.GET,
  });

export const linkSOWsToProject = (projectId, sowIds) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/${projectId}/link-sows`,
    method: HttpMethod.POST,
    data: { sowIds: Array.isArray(sowIds) ? sowIds : [] },
  });

  
export const downloadProjectAdminDetails = (projectId) => 
httpRequest({
  url: `${PROJECT_ADMIN_API}/${projectId}/download-sow`,
  method: HttpMethod.GET,
}); 

export const getResourcingData = (projectId) => 
  httpRequest({
    url: `${PROJECT_ADMIN_API}/get-resourcing-detail/${projectId}`,
    method: HttpMethod.GET,
  })

export const updateResourcingData = (data) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/update-resourcing-detail`,
    method: HttpMethod.POST,
    data: data,
  });
export const updateBillableLeaves = (data) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/update-billable-leaves`,
    method: HttpMethod.POST,
    data: data,
  });
export const getBillableLeaves = (projectId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/get-billable-leaves/${projectId}`,
    method: HttpMethod.GET,
  });

export const getMaxBillableCount = (projectId) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/get-max-billable-count/${projectId}`,
    method: HttpMethod.GET,
  });

export const updateMaxBillableCount = (projectId, data) =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/update-max-billable-count/${projectId}`,
    method: HttpMethod.POST,
    data: data,
  });

export const getMonthlyProjections = (projectId) =>
  httpRequest({
    url:`${PROJECT_ADMIN_API}/${projectId}/resourcing-details`,
    method: HttpMethod.GET,
  })

export const sendTimesheetRecordNotification = () =>
  httpRequest({
    url: `${PROJECT_ADMIN_API}/notifications/send-timesheet-report`,
    method: HttpMethod.POST,
  });